/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { ProductDtoCreate } from '../../models/product-dto-create';
import { ProductItem } from '../../models/product-item';

export interface ProductControllerCreate$Params {
      body: ProductDtoCreate
}

export function productControllerCreate(http: HttpClient, rootUrl: string, params: ProductControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ProductItem;
}>> {
  const rb = new RequestBuilder(rootUrl, productControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: ProductItem;
      }>;
    })
  );
}

productControllerCreate.PATH = '/product';
